import SVG from "../../../Components/SVG";
import { toPersianDigits } from "../../../helper/toPersianDigits";

export default function NotifCard({
  title = "",
  description = "",
  time = "",
  isSeen = false,
  onClick,
  data,
}) {
  const timeAgo = (isoString) => {
    const now = new Date();
    const past = new Date(isoString);

    const diffMs = now - past; // milliseconds difference
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMon = Math.floor(diffDay / 30);
    const diffYr = Math.floor(diffDay / 365);

    if (diffSec < 60) return `${diffSec} ثانیه پیش`;
    if (diffMin < 60) return `${diffMin} دقیقه پیش`;
    if (diffHr < 24) return `${diffHr} ساعت پیش`;
    if (diffDay < 30) return `${diffDay} روز پیش`;
    if (diffMon < 12) return `${diffMon} ماه پیش`;
    return `${diffYr} سال پیش`;
  };
  return (
    <div
      className="w-full p-3 sm:p-3 rounded-xl flex items-center gap-3 sm:gap-3 bg-zi-bg1-light dark:bg-zi-inputbg-dark cursor-pointer hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-light/30"
      onClick={onClick}
    >
      <div className="relative size-10 sm:size-10 aspect-square rounded-full flex justify-center items-center bg-zi-bg2-light dark:bg-zi-bg2-dark">
        {!isSeen && (
          <div className="absolute rounded-full size-2.5 sm:size-2.5 top-0 right-0 bg-amber-400"></div>
        )}
        <SVG
          name="notification"
          classname="size-5 sm:size-5 stroke-zi-border-dark dark:stroke-zi-border-light"
        />
      </div>

      <div className="flex-1 min-w-0 overflow-hidden flex flex-col gap-4">
        <div className="w-full flex items-center justify-between gap-1">
          <h5 className="font-medium text-base sm:text-lg text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
            {data.title}
          </h5>
          <span className="text-xs text-nowrap text-zi-text-light/50 dark:text-zi-text-dark/50">
            {data ? toPersianDigits(timeAgo(data.created_at)) : ""}
          </span>
        </div>

        <div className="w-full min-w-0 flex items-center gap-1 sm:gap-1 text-sm sm:text-base">
          <p className="flex-1 min-w-0 text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
            {data.description}
          </p>
          <button type="button" className="text-cyan-600 underline text-xs">
            مطالعه بیشتر
          </button>
        </div>
      </div>
    </div>
  );
}
